<template>
    <div>
        <b-tabs v-model="tabIndex">
            <b-tab title="Arquivo .OFX">
                <Alert type="info">
                    <span>
                        Selecione a <b>Conta Bancária</b> e o arquivo no formato
                        <b> .ofx </b> para importar o extrato.
                    </span>
                    <br />
                </Alert>
                <Select title="Conta Bancária" field="bankAccount" :required="true" v-model="bankAccount"
                    url="api/v1/financial/bank-account/select-all" :showNewRegister="false" />
                <InputFile ref="inputFile" title="Arquivo" field="file" formName="importOfxForm" :required="true"
                    accept=".ofx" v-model="file" />
                <div class="text-center">
                    <Button _key="btnImportOfx" title="Importar" type="primary" size="small" :disabled="disabledOfx"
                        :clicked="importOfx" />
                </div>
            </b-tab>
            <b-tab title="Open Finance">
                <Alert type="info">
                    <span>
                        Importe os extratos das <b>Contas Vinculadas</b> ao Open Finance. Se <b>NÃO</b> houver
                        nenhuma listada, adicione-as no cadastro da Conta Bancária.
                    </span>
                    <br />
                </Alert>
                <ImportPluggy />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>

import Alert from "@/ui/layout/Alert";
import Button from "@/ui/forms/Button";
import Select from "@/ui/forms/Select";
import InputFile from "@/ui/forms/InputFile";

import ImportPluggy from './ImportPluggy.vue'
import BankReconciliationService from "../../services/bankReconciliation.service";
import api from "@/lib/api";

import { mapMutations } from "vuex";

export default {
    name: "ImportModal",
    components: { Alert, Button, Select, InputFile, ImportPluggy },
    data() {
        return {
            tabIndex: 1,
            bankAccount: {},
            file: null,
        };
    },
    computed: {
        disabledOfx() {
            return !this.file || !this.bankAccount.id;
        },
    },
    methods: {
        ...mapMutations("generic", ["addEvent", "hideModal", "addLoading", "removeLoading"]),
        ...mapMutations("validation", ["resetValidation"]),
        async importOfx() {
            if (this.disabledOfx) return;

            this.addLoading("btnImportOfx");
            try {
                let formData = new FormData();
                formData.append("File", this.file);
                formData.append("BankAccountId", this.bankAccount.id);

                let response = await api.post(BankReconciliationService.urlImportOfx, formData);
                let content = (response.data && response.data.content) || {};

                this.$toasted.success((content.imported || 0) + " importado(s), " + (content.ignored || 0) + " ignorado(s).");
                this.addEvent({ name: "fileLoaded" });
                this.clearOfxForm();
                this.hideModal();
            } finally {
                this.removeLoading(["btnImportOfx"]);
            }
        },
        clearOfxForm() {
            this.bankAccount = {};
            if (this.$refs.inputFile) this.$refs.inputFile.clear();
            else this.file = null;
            this.resetValidation("importOfxForm");
        },
    },
};
</script>
